import React from 'react';
import { MonitorIcon } from 'lucide-react';
import { CreativeDirectoryPage, CreativeArtist } from '../../components/creative/CreativeDirectoryPage';
const artists: CreativeArtist[] = [{
  id: '1',
  name: 'Alex Kim',
  title: 'Digital Artist',
  specialties: ['Digital Painting', '3D Modeling', 'Concept Art'],
  rating: 4.8,
  reviewCount: 145,
  imageUrl: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
  available: true,
  priceRange: '$250-700'
}, {
  id: '2',
  name: 'Jordan Taylor',
  title: 'Digital Illustrator',
  specialties: ['Vector Art', 'Character Design', 'Animation'],
  rating: 4.6,
  reviewCount: 87,
  imageUrl: 'https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
  available: true,
  priceRange: '$200-600'
}];
const DigitalArtists = () => <CreativeDirectoryPage title="Digital Artists" subtitle="Connect with skilled digital artists specializing in various styles and techniques" icon={<MonitorIcon className="h-8 w-8" data-id="element-9303" data-mp="1l4ze06qtli9s" />} profileBasePath="/creative/digital-artists" artists={artists} data-id="element-9302" data-mp="3gryc2funnxp4" />;
export default DigitalArtists;